"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _translations = require("../../libs/translationsUtils/translations");

var spoilerPlugin = {
  init: function init(editor) {
    editor.ui.addButton('Spoiler', {
      label: 'Spoiler',
      command: 'spoiler',
      icon: 'spoiler'
    });
    editor.widgets.add('spoiler-widget', {
      editables: {
        content: {
          selector: '.content-spoiler'
        }
      },
      init: function init() {
        this.once('focus', function () {
          var spoilerText = this.element.$.getElementsByClassName('content-spoiler')[0];
          spoilerText.focus();
        });
      },
      upcast: function upcast(elem) {
        return elem.classes && elem.classes.indexOf('spoiler-container') !== -1;
      },
      allowedContent: 'div{*}(*);br',
      template: function template() {
        var spoilerTemplate = "<div class='spoiler-container'>\n            <div class='hideBtn'>".concat((0, _translations.t)('Common', 'bb.spoiler.hide-content'), "</div>\n            <div class='content-spoiler'></div>\n          </div>");
        return spoilerTemplate;
      }
    });
    editor.addCommand('spoiler', {
      exec: function exec() {
        var range = editor.getSelection().getRanges()[0];
        var allParents = range.endContainer.getParents();
        var currentSpoiler = null;
        var topParent = null;

        for (var idx = 0; idx < allParents.length - 1; idx++) {
          var parent = allParents[idx];

          if (parent.$.classList && parent.$.classList.contains('cke_widget_spoiler-widget')) {
            currentSpoiler = parent;
            topParent = range.endContainer.getParents()[idx + 3];
            break;
          }
        }

        if (currentSpoiler) {
          var newLine = topParent;
          var list = [];

          do {
            list.push(newLine);
            newLine = newLine.getNext();
          } while (newLine);

          list.reverse().forEach(function (item) {
            return item.insertAfter(currentSpoiler);
          });
          range.moveToPosition(list[0], window.CKEDITOR.POSITION_BEFORE_END);
          editor.getSelection().selectRanges([range]);
        } else {
          editor.execCommand('spoiler-widget');
        }
      }
    });
  }
};
var _default = spoilerPlugin;
exports.default = _default;